import React, { useState } from 'react';
import { Form, Input } from 'semantic-ui-react';
import { NumericFormat, NumberFormatValues } from 'react-number-format';

type AdditionalBudgetItemsValues = {
    programAdministrationOverhead?: number | null;
    otherContingency?: number | null;
};

type Props = {
    values?: AdditionalBudgetItemsValues;
    onChange: (values: AdditionalBudgetItemsValues) => void;
};

const AdditionalBudgetItems: React.FC<Props> = ({ values = {}, onChange }) => {
    const [formValues, setFormValues] = useState<AdditionalBudgetItemsValues>({
        programAdministrationOverhead: values.programAdministrationOverhead ?? null,
        otherContingency: values.otherContingency ?? null,
    });

    // useEffect(() => {
    //     onChange(formValues);
    // }, [formValues, onChange]);

    const handleChange = (
        name: string,
        value: any
    ) => {
        setFormValues((prev) => ({
            ...prev,
            [name]: value === '' ? null : Number(value),
        }));
        onChange({ ...formValues, [name]: value === '' ? null : Number(value) });
    };

    return (
        <Form>
            {/* <Form.Field>
                <label>Program administration and overhead</label>
                <NumericFormat
                    thousandSeparator
                    allowNegative={false}
                    customInput={Input}
                    name="programAdministrationOverhead"
                    value={formValues.programAdministrationOverhead ?? ''}
                    onValueChange={(values: NumberFormatValues) => handleChange('programAdministrationOverhead', values.value ? values.value : null)}
                    placeholder="Enter amount..."
                    label={{ basic: true, content: '$' }}
                    labelPosition="right"
                    min={0}
                />
            </Form.Field> */}
            <Form.Field>
                <label>Contingency and additional budget items</label>
                <NumericFormat
                    thousandSeparator
                    allowNegative={false}
                    customInput={Input}
                    name="otherContingency"
                    value={formValues.otherContingency ?? ''}
                    onValueChange={(values: NumberFormatValues) => handleChange('otherContingency', values.value ? values.value : null)}
                    placeholder="Enter amount..."
                    label={{ basic: true, content: '$' }}
                    labelPosition="right"
                    min={0}
                />
            </Form.Field>
        </Form>
    );
};

export default AdditionalBudgetItems;
